import { StaticQuery, graphql } from 'gatsby'
import React from 'react'
import Img from 'gatsby-image'

const SupportoMedia = ({ data }) => (
  <StaticQuery
    query={graphql`
      query {
        brandforum: file(relativePath: {eq: "contents/logo-brandforum.jpg"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        }
        WUD2018: file(relativePath: {eq: "contents/WUD2018_logo.jpg"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={staticData => {
      const { title, sponsors } = data;
      const [brandforum/*, WUD2018*/] = sponsors;
      return (
        <section id="supporto-media" className="section supporto-media text-center" aria-labelledby="region-supporto-media">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-sm-10 col-sm-offset-1">
                <h1 id="region-supporto-media" className="section__title">{title}</h1>
                <div className="row">
                  <div className="col-sm-4 col-md-offset-4">
                    <a href="http://www.brandforum.it/" title={brandforum.title} className="media-partner__logo text-center" target="_blank" rel="noopener noreferrer">
                      <Img fluid={staticData.brandforum.childImageSharp.fluid} alt={brandforum.title} className="media-partner__img" />
                      <span className="sponsor__name">{brandforum.title}</span>
                      <span className="sponsor__desc">{brandforum.desc}</span>
                    </a>
                  </div>
                  {/* <div className="col-sm-4">
                    <a href="https://www.wudrome.it/" title={WUD2018.title} className="media-partner__logo text-center" target="_blank" rel="noopener noreferrer">
                      <Img fluid={staticData.WUD2018.childImageSharp.fluid} alt={WUD2018.title} className="media-partner__img" />
                      <span className="sponsor__name">{WUD2018.title}</span>
                      <span className="sponsor__desc">{WUD2018.desc}</span>
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    }}
  />
);

export default SupportoMedia;
